const { registerBlockType } = wp.blocks;

import Edit from './edit';
import Save from './save';

registerBlockType('app/tab-sumicity', {
  title: 'Guia',
  description:
    'Guia para agrupar informações e blocos, pensando na praticidade do uso para o usuário final.',
  icon: 'insert',
  category: 'design',
  edit: (props) => <Edit {...props} />,
  save: (props) => <Save {...props} />,
});
